// 子账号

import { HttpFeeBlackList, HttpFeeBlackDel, HttpSaveFeeBlack } from '@/service/billing';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    components: {
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            // Tabs: {show: true},
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpFeeBlackList,
        handleOperates(params = "", type, batch) {
            switch (type) {
                // case 'add':
                //     this.operate = {
                //         title: '新增',
                //         show: true,
                //         width:700,
                //         component: "compUpdate",
                //         showFooter: false,
                //         querytype: "add",
                //         alertbox:'alertbox'
                //     }
                //     break;
                case "add":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ id:params },
                        title: "添加黑名单",
                        showDesc:false,
                        width:450,
                        formdata:[
                            {
                                label: "组织",
                                tag: 'vSelect',
                                key: 'orgId',
                                show:true,
                                options:this.getSelfmanageorgList,
                                span:24,
                                props:{
                                    filterable:true,
                                }
                            },
                            {
                                label: '费用类型',
                                tag: 'vSelect',
                                key: 'expenseType',
                                options:[
                                    {value:0,label:'仓库作业费'},
                                    {value:1,label:'仓储费'},
                                    {value:2,label:'快递费'},
                                    {value:3,label:'增值服务费'},
                                ],
                                span:24,
                                props:{
                                    filterable:true,
                                },
                                show: true,
                            },
                        ],
                        ajaxRequest:HttpSaveFeeBlack
                    }
                    break;
                case 'del':
                    // console.log(type);
                    this.operate = {
                        show: true,
                        alert: 'error',
                        params: { id: params },
                        title: '删除子账号',
                        desc: '删除后不可恢复，是否确认删除？',
                        ajaxRequest: HttpFeeBlackDel,
                    }
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row;
            return [
                {
                    label: this.$t('global.common.delete', { defaultValue: "删除" }),
                    show: true,
                    params: id,
                    operate: 'del'
                },
            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList']),
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t("global.common.cusorg", {defaultValue: "客户组织"}),
                    tag: 'vSelect',
                    key: 'EQ_orgId',
                    show: true,
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label:this.$t('',{defaultValue:'费用类型'}),
                    tag:'vSelect',
                    key:'EQ_expenseType',
                    show:true,
                    required:true,
                    options:[
                        {value:'',label:'全部'},
                        {value:0,label:'仓库作业费'},
                        {value:1,label:'仓储费'},
                        {value:2,label:'快递费'},
                        {value:3,label:'增值服务费'},
                    ]
                },
                {
                    label: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                    tag: 'vDatepicker',
                    style: "width:250px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                    show: true,
                }
                // {
                //     label: this.$t('fbb.bill.freeze_createdat', { defaultValue: "创建日期" }),
                //     tag: 'vDatepicker',
                //     style: "width:200px",
                //     key: 'GE_createdAt',
                //     props: {
                //         format: 'yy-mm-dd',
                //         confirm: false,
                //     },
                //     show:true,
                // },
                // {
                //     label: "-",
                //     tag: 'vDatepicker',
                //     style: "width:200px",
                //     key: 'LE_createdAt',
                //     props: {
                //         format: 'yy-mm-dd',
                //         confirm: false,
                //     },
                //     show:true,
                // },
            ]
        },
        columns() {
            return [
                {
                    title: '操作',
                    maxWidth: 80,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('global.common.organization', { defaultValue: '组织' }),
                    render: (h, { row }) => {
                        let orgId = row.orgId
                        const { label } = this.getSelfmanageorgList.find(function (item) {
                            return item.value == orgId
                        }) || {};
                        return <div>
                            <div>{label || '--'}</div>
                        </div>
                    }
                },
                {
                    title:'费用类型',
                    key:'expenseType',
                    render:(h,{row})=>{
                        return row.expenseType === 0 ? '仓库作业费' : row.expenseType === 1 ? '仓储费' : row.expenseType === 2 ? '快递费' : row.expenseType === 3 ? '增值服务费' : '--'
                    }
                },
                {
                    title:'创建人',
                    key:'createdName',
                },
                {
                    title: '创建时间',
                    key: 'createdAt',
                },

            ];
        },
    },
};




